import React from 'react';
import './InstagramShowcase.scss';
import { FaInstagram } from 'react-icons/fa';
import monaInsImage from '../../assets/testimonial/mona_ins_image.jpg';
import useAnalytics from '../../hooks/useAnalytics';

const InstagramShowcase = () => {
  const { trackEvent } = useAnalytics();
  
  const instagramStats = {
    username: 'mona.klinik',
    posts: '217',
    followers: '45.2K',
    following: '1',
    category: 'Health/beauty',
    businessName: 'Mona Klinik',
    phone: '0532 294 40 05',
    address: 'Kadıköy, Osmanağa Mah. Nal Sk. NO: 11',
    email: 'monaclinik@gmail.com',
    hashtags: ['#implant', '#zirkonyum', '#diştedavisi', '#monadental']
  };

  const handleInstagramClick = () => {
    // Amplitude event tracking
    trackEvent('instagram_follow_click', {
      username: instagramStats.username,
      source: 'instagram_showcase',
      followers: instagramStats.followers,
      posts: instagramStats.posts
    });
    
    window.open('https://instagram.com/mona.klinik', '_blank');
  };

    return (
    <section className="instagram-showcase" data-aos="fade-up" data-aos-duration="1500">
      <div className="container">
        <div className="instagram-card">
          <div className="instagram-content">
            {/* Left - Profile */}
            <div className="profile-section">
              <div className="profile-avatar">
                <img src={monaInsImage} alt="Mona Klinik" className="profile-image" />
              </div>
              <div className="profile-info">
                <h3 className="username">@{instagramStats.username}</h3>
              </div>
            </div>

            {/* Center - Stats */}
            <div className="instagram-stats">
              <div className="stat-item">
                <span className="stat-number">{instagramStats.posts}</span>
                <span className="stat-label">gönderi</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">{instagramStats.followers}</span>
                <span className="stat-label">takipçi</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">{instagramStats.following}</span>
                <span className="stat-label">takip</span>
              </div>
            </div>

            {/* Right - Follow Button */}
            <div className="follow-section">
              <button className="follow-btn" onClick={handleInstagramClick}>
                <FaInstagram />
                <span>Takip Et</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InstagramShowcase; 